export default "__VITE_ASSET__CpmfQgYX__"